export default __webpack_public_path__ + "static/media/epi-background-about-us.3fcd9890.jpg";